import { getModelState } from 'client/data/luckdragon/model';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import {
  COPYRIGHT_TRADEMARK_BREADCRUMBS,
  COPYRIGHT_TRADEMARK_CONTENT_PATH,
} from 'site-modules/editorial/constants/about';
import { parseContent } from 'client/data/cms/content';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { CopyrightTrademark } from './copyright-trademark';

export const pageOptions = {
  name: 'other_about_us_copyright_trademark_notices',
  category: 'other',
  preload: store => {
    const preloader = new ModelPreloader(store);

    preloader.resolve(`content["${COPYRIGHT_TRADEMARK_CONTENT_PATH}"]`, CmsModel);

    return preloader.load();
  },
  seo: state => {
    const modelState = getModelState(state);
    const content = parseContent(modelState.get(`content["${COPYRIGHT_TRADEMARK_CONTENT_PATH}"]`, CmsModel));

    return {
      ...getMeta(content),
      title: content.title,
      jsonld: [getBreadcrumbSchema(COPYRIGHT_TRADEMARK_BREADCRUMBS)],
    };
  },
  component: CopyrightTrademark,
  decorator: EdmundsCpaNoAdhesionDecorator,
};

export default pageDefinition(pageOptions);
